import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { FormErrorMessageSpan,WhiteCardWrapper, CommonTitleDiv } from 'views/common-styled-components';
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import { useDispatch, useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import panDetailsSelector from './kyc-details.selector';
import { useForm } from 'react-hook-form';
import KycStatusMessage from './kyc-status-message';
import '../../../font-icon.css';
import { checkKycStatus } from './kyc-details.actions';
import * as profileviewActions from '../profile-view.actions';
import { getEncryptedUserId,isBtoCFlow, redirectToHome } from '__utils/common-utils';
import CartSummary from 'components/cart-summary/index';
import { CommonStyledComponentProps } from '__utils/type';
import ProfileViewSelector from '../profile-view.selector';
import * as Actions from "constants/actions";
import { useDeepCompare } from 'hooks/use-deep-memo';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import CartSelector from 'views/cart/cart.selector';
import { LayoutContext } from 'components/app-routes';

const PanDetailsWhiteCard = styled.div<CommonStyledComponentProps>`
    .inner-cont {
        padding: 15px 0px;
        display: flex;
    }
    .desc {
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: ${COLOR.BOLD_GRAY};
            
    }
    h3 {
        font-weight: 600;
        font-size: 18px;
    }
    input{
        width: ${(props: any) => props.isMobile ? "" : "328px"};
    }
    input::-webkit-input-placeholder {
        font-size: 14px;
        color: #A1A6A7;    
        font-weight: lighter;   
    }

`;
const PanSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    width: 160px;
    margin-top: 2rem; 
    font-size: 14px; 
`;
const SuccessBtnWhite = styled(SuccessButtonWhiteBg) <CommonStyledComponentProps>`
    width: 160px;
    font-size: 14px;
    margin-top: 10px; 
    border: 1px solid ${COLOR.GREEN};
    &:hover,
    &:focus,
    &:active {
        background-color: transparent;
        border-color: ${COLOR.GREEN};
        color: ${COLOR.GREEN};
    }
`;
const KycDetails: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const dispatch = useDispatch();
    const { kycDetails } = propsToJS(useSelector(panDetailsSelector));
    const { nameInHeader } = propsToJS(useSelector(ProfileViewSelector));
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { register, handleSubmit, formState: {errors}, setValue } = useForm({ mode: 'onChange' });
    const [ pan, setPan ] = useState<string>("");
    const [ showSkipBtn, setShowSkipBtn ] = useState<boolean>(false);
    const { profileView } = propsToJS(useSelector(ProfileViewSelector));
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        SetLayoutProps({
            config: {title: 'Investor Profile'}
        })
        dispatch(profileviewActions.fetchGetProfileView(getEncryptedUserId()));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const resetKycDetails = () => {
        dispatch({
            type: Actions.FETCH_CHECK_KYC_STATUS_SUCCESS,
            payload: {
                data: null
            }
        })
    }
    const clearPan = (setClear: boolean) => {
        setClear && setValue('pan', "");
        resetKycDetails();
    }
    const onSubmitPanDetails = (panDetails: any) => {
        Mixpanel.track(getEventName("checkKycStatus", "clicked", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        if(profileView?.registeredWithBse !== 3){
            dispatch(checkKycStatus(panDetails.pan))
            setPan(panDetails.pan);
        }

    };
    
    useEffect(() => {
        if (profileView?.pan)
        {
            dispatch(checkKycStatus(profileView.pan))
            setPan(profileView.pan);
        }
        else if (!profileView?.pan && !cartDetails)
        {
            setShowSkipBtn(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ useDeepCompare(profileView) ]);
    useEffect(() => {
        if (cartDetails && cartDetails?.noOfItems > 0)
        {
            setShowSkipBtn(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ useDeepCompare(cartDetails) ])

    return (<div>
        <WhiteCardWrapper isMobile={ isMobile } fullWidth>
            <PanDetailsWhiteCard isMobile={ isMobile }>
                { !isMobile && <CartSummary /> }
                { !isMobile && <CommonTitleDiv>Investor Profile</CommonTitleDiv> }
                <div className="inner-cont">
                    <div className="text">
                        <h3 >Hi { nameInHeader },</h3>
                        <br />
                        <p className="desc">Let's check KYC status of your PAN in order to proceed with investing in mutual funds.</p>
                        <br />
                        <form name="panDetails" onSubmit={ handleSubmit(onSubmitPanDetails) }>
                            <p style={ { fontSize: "14px", color: "#212121" } }>PAN number</p>
                            <input
                                name='pan'
                                type="text"
                                defaultValue={ pan }
                                onKeyUp={ resetKycDetails }
                                placeholder="Enter PAN Number"
                                style={ { marginTop: "10px" } }
                                ref={register({
                                    required: "Please enter PAN number",
                                    pattern: {
                                        value: /[A-Z]{5}\d{4}[A-Z]/,
                                        message: "Please enter valid PAN number"
                                    }
                                }) }
                                disabled={profileView?.registeredWithBse === 3}
                            />
                            <br />
                            { errors.pan ? <FormErrorMessageSpan style={ { marginTop: "1rem", fontSize: "14px" } }>{ errors.pan.message }</FormErrorMessageSpan> : null }
                            { !kycDetails && <PanSubmitButton type="submit" isMobile={ isMobile }>Check KYC Status</PanSubmitButton> }<br />
                            { (!kycDetails && showSkipBtn) ? <SuccessBtnWhite isMobile={ isMobile } onClick={ () => redirectToHome() }>Go to Homepage  &gt;&gt;</SuccessBtnWhite> : null }

                        </form>

                        { kycDetails ? <KycStatusMessage pan={ pan } clearPan={ clearPan } /> : null }
                    </div>
                </div>
            </PanDetailsWhiteCard>
        </WhiteCardWrapper>
    </div>);
};

export default KycDetails;

